import request from '@/utils/request'

let SignApi = {
  /*获取数据*/
  getData(data) {
    return request._get('/shop/plus.sign/index', data);
  },
  /*保存数据*/
  saveData(data) {
    return request._post('/shop/plus.sign/index', data);
  },
  /*用户签到列表*/
  getSignList(data) {
    return request._post('/shop/plus.sign/lists', data);
  },
}
export default SignApi;



// WEBPACK FOOTER //
// ./src/api/sign.js